<mat-dialog-content>
  <div class="template__close_button" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </div>
  @if (detailsURL) {
    <div class="template__details_button">
      <a href="{{ detailsURL }}" target="_blank" rel="noopener noreferrer" title="Go to details"
        ><mat-icon>north_east</mat-icon></a
      >
    </div>
  }

  <div class="template__container" fxLayout="row wrap" fxLayoutAlign="start" [ngClass]="{is_place: isPlace}">
    <div class="template__image" [style.backgroundImage]="backgroundImage" fxFlex="1 0 15.625rem" @fadeInAnimation>
    </div>

    <div
      fxFlex="1 0 100%"
      fxFlex.lt-sm="0 1 auto"
      fxLayout="row wrap"
      fxLayoutAlign="start start"
      class="template__content"
      @fadeInAnimation
    >
      <div class="template__details" fxFlex="1 1 100%" fxLayout="row wrap">
        @if (data?.details?.from_time_display) {
          <h4 fxFlex="1 1 100%">
            <strong>
              {{ data?.details?.from_time_string }}
              @if (data?.details?.from_time_string && data?.details?.from_time_display) {
                <span>.</span>
              }
              {{ getFormattedTime($safeNavigationMigration(data?.details?.from_time_display)) }}
            </strong>
          </h4>
        }

        <h2 fxFlex="1 1 100%">
          {{ data?.details?.title }}
        </h2>

        <h6>
          {{ data?.details?.category }}
          @if (data?.details?.category !== data?.details?.subcategory) {
            <span>
              {{ data?.details?.subcategory }}
            </span>
          }
        </h6>

        @if (data?.details?.status) {
          <div fxFlex="1 1 100%">
            <h5>STATUS</h5>
            <p>{{ data?.details?.status }}</p>
          </div>
        }

        @if (data?.details?.provider_booking_reference) {
          <div fxFlex="1 1 100%">
            <h5>BOOKING REFERENCE</h5>
            <p>{{ data?.details?.provider_booking_reference }}</p>
          </div>
        }

        @if (data?.details?.reservation_details && data?.details?.status_slug === 'confirmed') {
          <div fxFlex="1 1 100%">
            <h5 class="title">CONFIRMATION DETAILS</h5>
            <div [innerHTML]="$safeNavigationMigration(data?.details?.reservation_details)"></div>
          </div>
        }

        @if (data?.details?.editorial_content?.length) {
          <div class="template__editorial_content" fxFlex="1 1 100%">
            @for (content of data?.details?.editorial_content; track content) {
              <div>
                <h5>{{ content.title | uppercase }}</h5>
                <div [innerHTML]="content.content"></div>
              </div>
            }
          </div>
        }

        @if (data?.details?.description && isPlace) {
          <div class="template__place_description" fxFlex="1 1 100%">
            <h5>DESCRIPTION</h5>
            <div [innerHTML]="$safeNavigationMigration(data?.details?.description)"></div>
          </div>
        }

        @if (reviews$ | async; as reviews) {
          @if (reviews.length > 0) {
            <ess-review-list [reviews]="reviews" [totalRating]="averageFeedbackScore"></ess-review-list>
          }
        }

        @if (data?.details?.type_slug === 'accommodation') {
          <div fxFlex="1 1 100%">
            @if (data?.details?.hotel_check_out_date) {
              <div>
                <h5>CHECK OUT DATE</h5>
                <p>{{ data?.details?.hotel_check_out_date }}</p>
              </div>
            }
            @if (data?.details?.number_of_nights) {
              <div>
                <h5>NUMBER OF NIGHTS</h5>
                <p>{{ data?.details?.number_of_nights }}</p>
              </div>
            }
            @if (data?.details?.amenities) {
              <div>
                <h5>ESSENTIALIST AMENITIES</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.amenities)"></div>
              </div>
            }
          </div>
        }

        @if (data?.details?.status_slug === 'proposal' || data?.details?.is_alternative_for) {
          <div fxFlex="1 1 100%">
            @if (data?.details?.price_from || data?.details?.price_to) {
              <div>
                <h5>PRICE</h5>
                @if (data?.details?.price_from) {
                  <p>${{ data?.details?.price_from }}</p>
                }
                @if (data?.details?.price_to) {
                  <p>
                    @if (data?.details?.price_from) {
                      <span>-</span>
                    }
                    ${{ data?.details?.price_to }}
                  </p>
                }
                @if (data?.details?.price_details) {
                  <p>{{ data?.details?.price_details }}</p>
                }
              </div>
            }
            @if (data?.details?.whats_included) {
              <div>
                <h5>INCLUSIONS</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.whats_included)"></div>
              </div>
            }
            @if (data?.details?.opening_time) {
              <div>
                <h5>OPENING TIMES</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.opening_time)"></div>
              </div>
            }
            @if (data?.details?.duration && getFormattedTime($safeNavigationMigration(data?.details?.duration), true)) {
              <div>
                <h5>ESTIMATED DURATION</h5>
                <p>{{ getFormattedTime($safeNavigationMigration(data?.details?.duration), true) }}</p>
              </div>
            }
            @if (data?.details?.notes) {
              <div>
                <h5>NOTES</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.notes)"></div>
              </div>
            }
          </div>
        }

        @if (data?.details?.status_slug === 'confirmed') {
          <div fxFlex="1 1 100%">
            @if (data?.details?.meeting_point) {
              <div>
                <h5>PICK UP DETAILS</h5>
                <p>{{ data?.details?.meeting_point }}</p>
              </div>
            }
            @if (data?.details?.vehicle_type) {
              <div>
                <h5>VEHICLE TYPE</h5>
                <p>{{ data?.details?.vehicle_type }}</p>
              </div>
            }
            @if (data?.details?.contact_details) {
              <div>
                <h5>CONTACT DETAILS</h5>
                <p>{{ data?.details?.contact_details }}</p>
              </div>
            }
            @if (data?.details?.whats_included) {
              <div>
                <h5>INCLUSIONS</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.whats_included)"></div>
              </div>
            }
            @if (data?.details?.tipping) {
              <div>
                <h5>TIPPING</h5>
                <p>{{ data?.details?.tipping }}</p>
              </div>
            }
            @if (data?.details?.opening_time) {
              <div>
                <h5>OPENING TIME</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.opening_time)"></div>
              </div>
            }
            @if (data?.details?.duration && getFormattedTime($safeNavigationMigration(data?.details?.duration), true)) {
              <div>
                <h5>ESTIMATED DURATION</h5>
                <p>{{ getFormattedTime($safeNavigationMigration(data?.details?.duration), true) }}</p>
              </div>
            }
            @if (data?.details?.notes) {
              <div>
                <h5>NOTES</h5>
                <div [innerHTML]="$safeNavigationMigration(data?.details?.notes)"></div>
              </div>
            }
            @if (data?.details?.cancellation_policies) {
              <div>
                <h5>CANCELLATION POLICIES</h5>
                <p [innerHTML]="$safeNavigationMigration(data?.details?.cancellation_policies)"></p>
              </div>
            }
          </div>
        }

        @if (
          ((data?.details?.location && data?.details?.location.latitude && data?.details?.location.longitude) ||
            data?.details?.hotel) &&
          data?.details?.address_object
        ) {
          <div fxFlex="1 1 100%">
            <h5>LOCATION</h5>
            <p>
              <!-- Info to show when this dialog is openned from a nearby section -->
              @if (data?.details?.address && !data?.details?.address_object?.address) {
                <span>{{ data?.details?.address }}</span>
              }
              @if (data?.details?.city && !data?.details?.address_object?.city) {
                <span>, {{ data?.details?.city }}</span>
              }
              @if (data?.details?.zipcode && !data?.details?.address_object?.zipcode) {
                <span>, {{ data?.details?.zipcode }}</span>
              }
              <!-- Info to show when this dialog is openned from an itinerary (place has date) -->
              @if (data?.details?.address_object?.address) {
                <span>
                  {{ data?.details?.address_object?.address }}
                </span>
              }
              @if (data?.details?.address_object?.zipcode) {
                <span>
                  <br />
                  {{ data?.details?.address_object?.zipcode }}
                </span>
              }
              @if (data?.details?.address_object?.city) {
                <span> , {{ data?.details?.address_object?.city }} </span>
              }
              @if (data?.details?.address_object?.country) {
                <span>
                  {{ data?.details?.address_object?.country }}
                </span>
              }
              @if (data?.details?.address_object?.phone) {
                <span>
                  <br />
                  <a [href]="'tel:' + $safeNavigationMigration(data?.details?.address_object?.phone)">{{
                    data?.details?.address_object?.phone
                  }}</a>
                </span>
              }
            </p>
          </div>
        }
      </div>

      @if (data?.details?.location && data?.details?.location.longitude && data?.details?.location.latitude) {
        <div fxFlex="1 1 auto" @fadeInAnimation>
          <div class="template__map">
            <lib-ess-map
              gestureHandling="cooperative"
              [isUsingForm]="false"
              [entity]="data.details"
              [places]="[data.details]"
              width="100%"
            ></lib-ess-map>
          </div>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
